import { useEffect, useState } from 'react';
import DataNotFound from '../ui/loader/data-not-found';
import InnerLoader from '../ui/loader/inner-loader';
import { useApiCall } from '../custom-hooks/api-call';
import { Link } from 'react-router';
import { ChartMainCard } from '../LeadsDashboardComponents/ChartsHeader';
import { TeamAvailability } from '../LeadsDashboardComponents/StatCardIcons';



const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);
const StageColors = {
  "Need Analysis": "#3b82f6", // blue
  "Value Proposition": "#8b5cf6", // violet
  Review: "#14b8a6", // teal
  Proposal: "#0ea5e9", // sky
  Won: "#22c55e", // green
  Lost: "#ef4444", // red
  "Identify Decision": "#eab308", // yellow
};
export function RecentDealsTable({ apiData = [], apiLoading }) {



  return (

    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-green-light text-theme-green'}
      heading="Latest Deals"
      subHeading={"Track the most recent deals along with deal value and progress"}
    >
      {
        !apiLoading ? (

          <div className="!max-h-[480px] h-full min-h-[460px] overflow-auto">

            {apiData.length > 0 ? (


              <table className="min-w-full">
                <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-xs text-left font-medium text-gray-700 uppercase tracking-wider">
                      Deal Name
                    </th>
                    <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Stage
                    </th>
                    <th className="px-4 py-3 text-xs text-left font-medium text-gray-700 uppercase tracking-wider">
                      Deal Value
                    </th>
                    <th className="px-4 py-3 text-xs text-center font-medium text-gray-700 uppercase tracking-wider">
                      Assignee
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200 cursor-pointer transition-all duration-200">

                  {apiData.map((lead) => (
                    <tr key={lead.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <h6 className="font-semibold text-[12px] capitalize">{lead?.deal_name?.trim() ? lead.deal_name : "-"}</h6>
                        <span className='text-[10px]'>
                          {lead?.closed_date?.trim() ? lead?.closed_date : "-"}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center items-center">
                          <Badge
                            color={
                              StageColors[lead?.stage]
                            }
                          >
                            {lead?.stage}
                          </Badge>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <h6 className="font-medium text-[12px]">{lead?.deal_value ?? "-"}</h6>
                      </td>


                      <td className="px-4 py-3 text-center">
                        <div className='flex items-center justify-center'>
                          {lead?.owner?.trim() && (
                            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 text-[10px] font-semibold">
                              {lead.owner
                                .split(" ")
                                .map(n => n[0])
                                .slice(0, 2)
                                .join("")
                                .toUpperCase()}
                            </div>
                          )}
                        </div>


                      </td>
                    </tr>
                  ))}




                </tbody>


              </table>


            ) : (
              <DataNotFound title={"Leads"} />
            )}

          </div>

        ) : (
          <InnerLoader />
        )
      }
    </ChartMainCard>


  );
}
